import axios, { CancelToken } from "axios";

export const getInsuranceCarriersRequest = async ({
  cancelToken,
}: {
  cancelToken?: CancelToken;
}): Promise<Array<string>> => {
  const { data } = await axios.get<Array<string>>(`/api/insurance_carriers`, {
    cancelToken,
  });

  return data;
};
